import { Link } from 'react-router-dom';
import { useLocation, useRouteMatch } from 'react-router-dom';
import classes from './style.module.scss';

const TypeFilters = () => {
  const location = useLocation();
  const match = useRouteMatch();

  const selectedType = new URLSearchParams(location.search).get('type');
  const selectedTagTitle = new URLSearchParams(location.search).get('title');

  const genSearchQuery = (type) => {
    let searchQuery = '';
    if (type) {
      searchQuery += `type=${type}`;
    }
    if (selectedTagTitle) {
      searchQuery += `&title=${selectedTagTitle}`;
    }
    return searchQuery;
  };

  return (
    <div className={classes.typeFilters}>
      <Link
        to={`?${genSearchQuery('all')}`}
        className={`${
          (selectedType === 'all' || !selectedType) && classes.selected
        }`}
      >
        All
      </Link>
      <Link
        to={`?${genSearchQuery('article')}`}
        className={`${selectedType === 'article' && classes.selected}`}
      >
        Articles
      </Link>
      <Link
        to={`?${genSearchQuery('image')}`}
        className={`${selectedType === 'image' && classes.selected}`}
      >
        Images
      </Link>
      <Link
        to={`?${genSearchQuery('video')}`}
        className={`${selectedType === 'video' && classes.selected}`}
      >
        Videos
      </Link>
      <Link
        to={`?${genSearchQuery('file')}`}
        className={`${selectedType === 'file' && classes.selected}`}
      >
        Files
      </Link>
    </div>
  );
};

export default TypeFilters;
